/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findLots } from '../fn/lot/find-lots';
import { FindLots$Params } from '../fn/lot/find-lots';
import { FindLotsResponseDto } from '../models/find-lots-response-dto';
import { LotDto } from '../models/lot-dto';
import { patchLot } from '../fn/lot/patch-lot';
import { PatchLot$Params } from '../fn/lot/patch-lot';

@Injectable({ providedIn: 'root' })
export class GeneratedLotService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findLots()` */
  static readonly FindLotsPath = '/api/lots';

  /**
   * Finds lots.
   *
   * NOTE: Does not raise an error if the given auctionId is not found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findLots()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLots$Response(params: FindLots$Params, context?: HttpContext): Observable<StrictHttpResponse<FindLotsResponseDto>> {
    return findLots(this.http, this.rootUrl, params, context);
  }

  /**
   * Finds lots.
   *
   * NOTE: Does not raise an error if the given auctionId is not found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findLots$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLots(params: FindLots$Params, context?: HttpContext): Observable<FindLotsResponseDto> {
    return this.findLots$Response(params, context).pipe(
      map((r: StrictHttpResponse<FindLotsResponseDto>): FindLotsResponseDto => r.body)
    );
  }

  /** Path part for operation `patchLot()` */
  static readonly PatchLotPath = '/api/lots/{id}';

  /**
   * Patches an existing lot.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchLot()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchLot$Response(params: PatchLot$Params, context?: HttpContext): Observable<StrictHttpResponse<LotDto>> {
    return patchLot(this.http, this.rootUrl, params, context);
  }

  /**
   * Patches an existing lot.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchLot$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchLot(params: PatchLot$Params, context?: HttpContext): Observable<LotDto> {
    return this.patchLot$Response(params, context).pipe(
      map((r: StrictHttpResponse<LotDto>): LotDto => r.body)
    );
  }

}
